import styled from 'styled-components';
import { theme } from '@frameio/vapor';
import { SearchFieldWithI18n } from '../SearchField';

export const SEARCH_FIELD_HEIGHT = 56;

export const StyledSearchField = styled(SearchFieldWithI18n)`
  background: ${theme.colors.components.modal.background};
  border-radius: ${theme.radii[8]};
  box-shadow: none;
  display: flex;
  height: ${SEARCH_FIELD_HEIGHT}px;
  padding: 0 ${theme.spaces[8]};

  input::-webkit-input-placeholder {
    color: ${theme.colors.text.tertiary};
  }
  input::-moz-placeholder {
    color: ${theme.colors.text.tertiary};
  }
  input:-ms-input-placeholder {
    color: ${theme.colors.text.tertiary};
  }
  input::placeholder {
    color: ${theme.colors.text.tertiary};
  }

  /* TODO: remove this and use a large TextField size in SearchField once its in vapor */
  & > input[type='search'] {
    font-size: ${theme.fontSizes[90]};
    line-height: ${theme.lineHeights[100]};
    padding-left: ${theme.spaces[12]};
  }
`;
